export default [
  {
    title: 'DSR과 LTV가 뭔가요?',
    content: [
      {
        title: 'DSR이란?',
        description:
          '- DSR(Debt Service Ratio)은 개인의 연소득 대비 보유 중인 모든 대출의 연간 원리금 상환액이 차지하는 비율입니다. 예를 들어, 연소득 5,000만 원에 연간 원리금 상환액이 2,000만 원이라면 DSR은 2000 ÷ 5000 = 40%입니다.',
      },
      {
        title: 'LTV란?',
        description:
          '- LTV(Loan To Value)는 주택의 가격 대비 최대로 받을 수 있는 대출 한도를 뜻합니다. 예를 들어 LTV가 70%라면, 주택 가격의 70%까지 대출을 받을 수 있다는 뜻입니다.',
      },
    ],
  },
  {
    title:
      '구입 대상 아파트의 시세가 15억 원을 초과하더라도 대출이 가능한가요?',
    content: [
      {
        description:
          '- 네, 2022년 12월 1일부터 규제가 완화되어 15억 원 초과 아파트도 주택 구입 자금 목적의 대출이 가능합니다.',
      },
    ],
  },
  {
    title: '생애 첫 주택 구매 시, 얼마나 대출을 받을 수 있나요?',
    content: [
      {
        description:
          '- 생애 첫 주택 구매 시에는 집 값의 80%까지 (LTV 80%) 대출을 받을 수 있습니다. 이때의 대출 한도는 최대 6억 원입니다.',
      },
    ],
  },
];


// export default [
// {
//   title: 'DSR과 LTV가 뭔가요?',
//   content: `DSR이란?- DSR(Debt Service Ratio)은 개인의 연소득 대비 보유 중인 모든 대출의 연간 원리금 상환액이 차지하는 비율입니다.`
// },
// {
//   title: '구입 대상 아파트의 시세가 15억 원을 초과하더라도 대출이 가능한가요?',
//   content: `- 네, 2022년 12월 1일부터 규제가 완화되어 15억 원 초과 아파트도 주택 구입 자금 목적의 대출이 가능합니다.`
// },
// {
//   title: '생애 첫 주택 구매 시, 얼마큼 대출받을 수 있나요?',
//   content: `- 생애 첫 주택 구매 시에는 집 값의 80%까지 (LTV 80%) 대출을 받을 수 있습니다. 이때의 대출 한도는 최대 6억 원입니다.`
// }
// ];